import React from 'react';
import BasicInfoTab from './tabs/BasicInfoTab';
import SubscriptionDetailsTab from './tabs/SubscriptionDetailsTab';
import PricingTab from './tabs/PricingTab';
import ImageTab from './tabs/ImageTab';
import MealSpecificationsTab from './tabs/MealSpecificationsTab';

export default function SubscriptionContent({
  activeTab,
  values,
  setField,
  categories,
  addMealSpecification,
  removeMealSpecification,
  updateMealSpecification,
  t
}) {
  const commonProps = {
    values,
    setField,
    t
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case 'basic':
        return <BasicInfoTab {...commonProps} />;
      case 'details':
        return <SubscriptionDetailsTab {...commonProps} />;
      case 'pricing':
        return <PricingTab {...commonProps} />;
      case 'image':
        return <ImageTab {...commonProps} />;
      case 'meals':
        return (
          <MealSpecificationsTab 
            {...commonProps}
            categories={categories}
            addMealSpecification={addMealSpecification}
            removeMealSpecification={removeMealSpecification}
            updateMealSpecification={updateMealSpecification}
          />
        );
      default:
        return <BasicInfoTab {...commonProps} />;
    }
  };

  return (
    <div className="transition-all duration-300 ease-in-out pt-6">
      <div className="max-w-5xl mx-auto">
        {renderTabContent()}
      </div>
    </div>
  );
}
